import React from 'react';

import { FormattedMessage } from 'react-intl';

import NoResultsFound from '@images/svgs/noResultsFound.svg';

import messages from './messages';

type EmptyRecordProps = {
  colSpan: number;
};

const EmptyRecord = ({ colSpan }: EmptyRecordProps) => (
  <td colSpan={colSpan}>
    <div className="flex justify-center w-full h-full">
      <div className="sticky left-0">
        <div className="flex flex-col items-center justify-center mt-24 text-center text-gray-900">
          <img src={NoResultsFound} alt="" className="mb-[1.5rem]" />
          <div className="text-lg font-semibold">
            <FormattedMessage {...messages.empty_record_title} />
          </div>
          <div className="w-64 text-sm font-normal">
            <FormattedMessage {...messages.empty_record_description} />
          </div>
        </div>
      </div>
    </div>
  </td>
);

export default EmptyRecord;
